import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

function LoadingSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-teacher-bg">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teacher-purple-mid"></div>
    </div>
  );
}

function AccessDenied({ error, onLogout }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-teacher-bg">
      <div className="bg-white p-8 rounded-xl border border-teacher-border max-w-md text-center">
        <div className="text-teacher-red text-5xl mb-4">
          <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-teacher-text-primary mb-2">Access Denied</h2>
        <p className="text-teacher-text-secondary mb-4">{error || 'You are not authorized to access this dashboard.'}</p>
        <button
          onClick={onLogout}
          className="px-4 py-2 bg-teacher-purple-mid text-white rounded-lg hover:bg-teacher-purple transition-colors"
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}

export default function ProtectedRoute({ children }) {
  const { user, loading, isAuthenticated, error, logout } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isAuthenticated) {
    return <AccessDenied error={error} onLogout={logout} />;
  }

  return children;
}
